import styled from 'styled-components';

import { Box } from 'components/library';

export const Container = styled(Box)`
    width: 100%;
    ${({ theme, $borderColor }) => $borderColor && `border: 1px solid  ${theme[$borderColor]};`};
    ${({ $borderRadius }) => $borderRadius && `border-radius: ${$borderRadius}px;`};
    > * {
        background-color: transparent !important;
    }
`;
